import { useTranslation } from "react-i18next";
import { PartnersList } from "../../../partners/PartnersList";
import { SettingsSubHeader } from "../SettingsSubHeader";

/**
 * The partners of Juisci, pushed from "Partner sharing" (Figma
 * O4.settings.partners): the list of the objection screen's sheet, in the
 * settings stack.
 */
export function PartnersView(): React.JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex h-full flex-col">
      <SettingsSubHeader title={t("Our partners")} />
      <div className="flex-1 overflow-y-auto scroll-fog-y px-5 pb-12">
        <PartnersList layout="mobile" policies={null} />
      </div>
    </div>
  );
}
